export const SHOW_MORE_LIMIT = 6;
